import React, {useContext} from 'react';
import { AppContext } from '../../../services/translationContext';
import './events.scss';
import { Link, NavLink, useParams } from "react-router-dom";
import { EventCard } from '../../cards/event-card';
import Slider from '../../slider/slider';

const eventsList = [
  {
    "link": "https://www.wemakefuture.it/",
    "image": "https://d3t3s6w5yvhc3g.cloudfront.net/images/blog/wmf2026.jpg ",
    "title": "We Make Future",
    "where": "Bologna",
    "date": "26/06/2026",
    "dateRange": "24-26",
    "textButton": "learn_more"
  },
  {
    "link": "https://www.odoo.com/it_IT/event/business-show-bologna-11003/register",
    "image": "https://www.odoo.com/web/image/52481552-71eb4f3c/221012_NICO091.webp",
    "title": "Odoo Business Show",
    "where": "Bologna",
    "date": "16/06/2026",
    "textButton": "learn_more"
  },
  {
    "link": "https://www.odoo.com/fr_FR/event/business-show-skopje-9967/register?utm_campaign=20260317-business-show-skopje-en&utm_source=partner-sydea&utm_medium=partner",
    "image": "https://odoocdn.com/web/image/43049809-91c3dcb1/auditorium-exhibitors.webp",
    "title": "Odoo Business Show",
    "where": "Skopje",
    "date": "17/03/2026",
    "textButton": "learn_more"
  },
  {
    "link": "https://www.odoo.com/it_IT/event/business-show-firenze-9750/register?utm_campaign=20260310-business-show-firenze-it&utm_source=partner-sydea&utm_medium=partner",
    "image": "https://odoocdn.com/openerp_website/static/src/img/odoo-experience/2025/introduction-business-solution.webp",
    "title": "Odoo Business Show",
    "where": "Firenze",
    "date": "10/03/2026",
    "textButton": "learn_more"
  }
];

export const EventsSection = ({isMenu = false}) => {
  const { services: {TranslationsService} } = useContext(AppContext);

  return (
    <div className={`${isMenu ? '':'bkg-light'} d-flex flex-column`}>
      {!isMenu &&<h2 className='syd-title dark fw-bold pt-5 pb-3 px-3'>{TranslationsService.labels('upcoming_events')}</h2>}
      
      <Slider>
        {
          eventsList.map((event, i) => (
            <EventCard 
              key={i}
              colMD={3}
              colSM={12}
              title={event.title}
              link={event.link}
              date={event.date}
              dateRange={event.dateRange || ''}
              bgImage={event.image}
              where={event.where}
              textButton={event.textButton}
            />
          ))
        }
      </Slider>

      {/* <div className={`${isMenu ? '':'p-3'} d-flex flex-column`}>
        <div className='row gap-3 gap-lg-0'>
        {
            eventsList.map((event, i) => (
              <EventCard 
                key={i}
                colMD={3}
                colSM={12}
                title={event.title}
                link={event.link}
                date={event.date}
                bgImage={event.image}
                where={event.where}
                textButton={event.textButton}
              />
            ))
          }
        </div>
      </div> */}
    </div>
  );
};